import React from "react";
import { format, isValid, parseISO } from "date-fns";
import { enGB } from "date-fns/locale";
import { styled } from "styled-components";

enum DateTimeFormats {
  DATE = "dd-MM-yyyy",
  TIME = "HH:mm",
}

const Time = styled.time`
  white-space: nowrap;
`;

export const DateTime: React.FC<{ value: string; format: DateTimeFormats }> & { FORMAT: typeof DateTimeFormats } = ({
  value,
  format: _format,
}) => {
  const dateIsValid = isValid(parseISO(value));
  return dateIsValid ? <Time dateTime={value}>{format(new Date(value), _format, { locale: enGB })}</Time> : null;
};
DateTime.FORMAT = DateTimeFormats;
